module.exports = __webpack_public_path__ + "img/HC1015-167.fa18ffae.jpg";